import EvSavingsGraph from "./ev_savings_graph.vue";

Vue.component('ev-savings-graph', EvSavingsGraph)

const evSavingsVueEnvironment = new Vue({
    delimiters: ['[%', '%]'],
    el: '.js_evSavingsGraph',
});
